import { useQuery } from "react-query";
import DriverScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useState } from "react";
import {
  ICreateAndUpdateDriver,
  IRequestDriver,
} from "../../../types/driver.interface";
import { TModal } from "../../../types/common.type";
import utils from "../../../utils";

const CompanyContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedDriver, setSelectedDriver] =
    useState<ICreateAndUpdateDriver>();
  const [requestDriver, setRequestDriver] = useState<IRequestDriver>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
  });

  const resultDriver = useQuery(
    [values.useQueryKeys.getAllDriver, requestDriver],
    () =>
      api.postMethod.common.findDriver({
        ...requestDriver,
      })
  );

  const updateDriver = async (driverInfo: ICreateAndUpdateDriver) => {
    setLoading(true);
    const result = await api.putMethod.common.updateDriver(driverInfo);
    if (result) {
      resultDriver.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  const createDriver = async (driverInfo: ICreateAndUpdateDriver) => {
    setLoading(true);
    const result = await api.postMethod.common.createDriver(driverInfo);
    if (result) {
      resultDriver.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };
  const removeDriver = async (driverId: string) => {
    setLoading(true);
    const result = await api.deleteMethod.common.deleteDriver(driverId);
    if (result) {
      resultDriver.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };

  return (
    <Context.DriverScreen.Provider
      value={{
        resultDriver,
        requestDriver,
        setRequestDriver,
        showModal,
        setShowModal,
        selectedDriver,
        setSelectedDriver,
        loading,
        setLoading,
        updateDriver,
        createDriver,
        removeDriver,
      }}
    >
      <DriverScreen />
    </Context.DriverScreen.Provider>
  );
};

export default CompanyContainer;
